const HTML_TAG = /<\/?(p|br|ul|ol|li|strong|em|s|a)\b[^>]*>/i;

const ESCAPES: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

export function escapeHtml(text: string): string {
  return text.replace(/[&<>"']/g, (ch) => ESCAPES[ch] ?? ch);
}

/**
 * Templates saved before the rich editor existed are plain text. Turn those
 * into paragraphs so the editor (and the email) show the line breaks they had;
 * anything that already looks like editor HTML passes through untouched.
 */
export function toEditorHtml(value: string): string {
  if (value.trim() === "") return "";
  if (HTML_TAG.test(value)) return value;
  return value
    .split(/\n{2,}/)
    .map((block) => `<p>${escapeHtml(block).replace(/\n/g, "<br>")}</p>`)
    .join("");
}

/** True when the editor holds no visible text (an empty paragraph counts as empty). */
export function isRichTextEmpty(html: string): boolean {
  return (
    html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim() === ""
  );
}
